import { UseQueryOptions } from '@tanstack/react-query';

import { Send } from 'domains/campaigns/types';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import useQuery from '../useQuery';

import QueryKeys from './keys';

const useSendById = (sendId: number, reactQueryOptions?: UseQueryOptions<Send, Error>) =>
    useQuery(QueryKeys.SEND_ID(`${sendId}`), new PathWithID(CuredApiPaths.SENDS, sendId), reactQueryOptions);

export default useSendById;
